import { useEffect } from 'react';
import { ArrowLeftIcon, ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { business, routes } from '../data/site';
import { SiteLink } from '../components/SiteLink';
type ComingSoonProps = {
  title: string;
};
export function ComingSoon({
  title
}: ComingSoonProps) {
  useEffect(() => {
    document.title = `${title} | Pegasus Spas`;
    window.scrollTo(0, 0);
  }, [title]);
  return <main data-id="element-281" data-mp="dagrron5b046">
      <section className="w-full bg-water" data-id="element-282" data-mp="da73q6lnv314">
        <div className="mx-auto max-w-container px-5 py-16 sm:px-8 lg:py-20" data-id="element-283" data-mp="d8vzk5oazt9h">
          <p className="text-[14px] font-bold uppercase text-pegasus-blue" data-id="element-284" data-mp="99es56pbgm1o">Pegasus Spas</p>
          <h1 className="mt-2 text-h1-mobile font-semibold text-ink lg:text-h1-desktop" data-id="element-285" data-mp="n0jx8obge6je">{title}</h1>
          <p className="mt-4 max-w-2xl text-body text-ink/80 sm:text-body-lg" data-id="element-286" data-mp="i2i9vr6zvl24">
            This page is coming soon. In the meantime, call or text the showroom and we will help
            you directly.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3" data-id="element-287" data-mp="ry1x7p7htbf9">
            <SiteLink to={routes.home} className="inline-flex min-h-[48px] items-center gap-2 rounded-btn bg-pegasus-magenta px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-288" data-mp="x7bcz9y7onu3">
              <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-289" data-mp="1b6arvpvx9od2" />
              Back to Home
            </SiteLink>
            <a href={business.phoneHref} className="inline-flex min-h-[48px] items-center gap-2 rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-white" data-id="element-290" data-mp="1g3t4bq95elpt">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-291" data-mp="1tw0x76xb9sj8" />
              Call or text {business.phone}
            </a>
          </div>
        </div>
      </section>

      <section aria-label="Showroom details" className="w-full bg-white" data-id="element-292" data-mp="1yt94udku2e68">
        <div className="mx-auto grid max-w-container grid-cols-1 gap-6 px-5 py-12 sm:grid-cols-2 sm:px-8" data-id="element-293" data-mp="23v8aju41pn6c">
          <div className="flex items-start gap-2.5" data-id="element-294" data-mp="3sqje2dyft6e">
            <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-295" data-mp="3uz0ecmsgmscq" />
            <address className="text-[16px] not-italic leading-6 text-ink" data-id="element-296" data-mp="dhqp04mypmtk">
              {business.street}
              <br data-id="element-297" data-mp="8qs6qzieyeno" />
              {business.cityStateZip}
            </address>
          </div>
          <div className="flex items-start gap-2.5" data-id="element-298" data-mp="mi5kfwtn4ias">
            <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-299" data-mp="mgvmr8qp9c4o" />
            <div className="text-[16px] leading-6 text-ink" data-id="element-300" data-mp="igttnnz15r10">
              {business.hours.map(entry => <div key={entry.days} data-id="element-301" data-mp="wes2kdul0v94">
                  {entry.days} {entry.time}
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </main>;
}